export const headerSearch = () => {
    const searchWrappers = document.querySelectorAll('.header__search');

    if (!searchWrappers.length) return;

    const setMobileState = (wrapper, isOpen) => {
        const formWrap = wrapper.querySelector('.header__search-form-wrap');

        if (!formWrap) return;

        if (window.innerWidth > 992) {
            formWrap.style.maxHeight = '';
            formWrap.style.opacity = '';
            return;
        }

        formWrap.style.maxHeight = isOpen ? '64px' : '0';
        formWrap.style.opacity = isOpen ? '1' : '0';
    };

    const closeSearch = (wrapper) => {
        wrapper.classList.remove('header__search--active');
        setMobileState(wrapper, false);
    };

    const openSearch = (wrapper) => {
        wrapper.classList.add('header__search--active');
        setMobileState(wrapper, true);
    };

    searchWrappers.forEach((wrapper) => {
        const searchIcons = wrapper.querySelectorAll('.header__search-icon, .header__search-icon--follow');
        const formWrap = wrapper.querySelector('.header__search-form-wrap');

        if (!formWrap || !searchIcons.length) return;

        searchIcons.forEach((icon) => {
            icon.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();

                const shouldOpen = !wrapper.classList.contains('header__search--active');

                searchWrappers.forEach((otherWrapper) => {
                    if (otherWrapper !== wrapper) {
                        closeSearch(otherWrapper);
                    }
                });

                if (shouldOpen) {
                    openSearch(wrapper);
                } else {
                    closeSearch(wrapper);
                }
            });
        });
    });

    document.addEventListener('click', (event) => {
        const clickedInsideSearch = Array.from(searchWrappers).some((wrapper) =>
            wrapper.contains(event.target)
        );

        if (!clickedInsideSearch) {
            searchWrappers.forEach((wrapper) => closeSearch(wrapper));
        }
    });

    window.addEventListener('resize', () => {
        searchWrappers.forEach((wrapper) => {
            const isOpen = wrapper.classList.contains('header__search--active');
            setMobileState(wrapper, isOpen && window.innerWidth <= 992);
        });
    });
};